module.exports = __webpack_public_path__ + "static/media/bg5.287c6972.jpg";